import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { ADD, EDIT, IDLE, PENDING } from "const"
import { StateType, hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_CC_LIBRARY,
    StoreType,
    CcLibrarySetProps,
    LoadCcLibrarySetById,
    IsOwnerCcLibrarySet,
    setCcLibrarySetEdit,
    setCcLibrarySetReloadEdit,
    initCcLibrarySet,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import AccessDenied from "client/parts/accessDenied"
import Form from "./form"

const Edit = ({
    setId = null,
}: CcLibrarySetProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const set = useSelector((state: StoreType) => state.ccLibrarySet.setEdit)
    const reloadEdit = useSelector((state: StoreType) => state.ccLibrarySet.reloadEdit)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setCcLibrarySetReloadEdit(false))
        setTimeout(() => {
            dispatch(setCcLibrarySetReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (setId === 0) {
            dispatch(setCcLibrarySetEdit(initCcLibrarySet))
            reload()
        } else {
            setLoadState(PENDING)
            LoadCcLibrarySetById(setId, userData.accountId, project.id).then((res) => {
                dispatch(setCcLibrarySetEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    const addAccess = !project.id
        ? hasAccess(PRM_CC_LIBRARY, ADD)
        : hasProjectAccess(PRM_CC_LIBRARY, ADD)

    const editAccess = !project.id
        ? hasAccess(PRM_CC_LIBRARY, EDIT)
        : hasProjectAccess(PRM_CC_LIBRARY, EDIT)

    const isOwner = IsOwnerCcLibrarySet(project.id, set, userData)
    const allowedToEdit = editAccess || isOwner

    if (setId === 0 && !addAccess) return <AccessDenied />
    if (setId !== 0 && !allowedToEdit) return <AccessDenied />
    if (!set) return <NotFound />

    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {set.id ? `${lang.editComplianceSet} # ${set.id}` : lang.addComplianceSet}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form set={set} />
                }
                {
                    reloadEdit
                    && <Form set={set} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
